import React from 'react';
import { TextButton } from '../../../../../../components/Button';
import KubitTooltip from '../../../../../../components/KubitTooltip';

interface IProps {
  onClick: () => void;
}

const AddVariantAction = ({ onClick }: IProps) => {
  return (
    <KubitTooltip content={'Add the Second Variant'} placement="bottom">
      <TextButton onClick={onClick}>+ Add Variant</TextButton>
    </KubitTooltip>
  );
};

export default AddVariantAction;
